import { useState } from "react";
import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { FaFileExport, FaPlay, FaSearch } from "react-icons/fa";
import {
  BLUEMONEDDBUTTONS,
  GRAY_DARK,
  GRAY_NEUTRAL,
  GREENMONEDD,
  REDMONEDD,
  WHITE,
} from "../../../../constants/colors";
import moment from "moment";
import { HamburgerIcon } from "@chakra-ui/icons";
import {
  goToConsultaTransacaoCliente,
  goToSimplifiedDetailsSupervisorClient,
} from "../../../../routes/coordinator";
import { useNavigate } from "react-router-dom";
import { selectedClientHeader } from "../../../../atoms/selectedClientHeader";
import { useRecoilState } from "recoil";
import ClientFilterSelect from "../../../../defaultComponents/ClientFilterSelect";
import DateDropdown from "../../../../defaultComponents/dateDropdown";
import { FiPlus } from "react-icons/fi";
import {
  LinhaEsqueleto,
  useListagemProgressiva,
} from "../listagemProgressiva";

export default function ConsultaTransacoesClientes() {
  const navigate = useNavigate();
  const dataInicio = moment(Date())
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
  const dataFim = moment(Date()).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
  const id = useRecoilState(selectedClientHeader)[0];

  const initialValues = {
    clientFilter: id,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
    minValueFilter: 0,
    maxValueFilter: 0,
    balanceFilter: "",
  };

  const [filtros, setFiltros] = useState(initialValues);

  // Lista em duas etapas: nomes primeiro, valores depois. A consulta pesada é
  // cancelada ao sair da tela ou trocar de filtro. Ver listagemProgressiva.
  const { linhas, valoresCarregados } = useListagemProgressiva(filtros, id);

  function onChangeBalanceFilter(e: any) {
    setFiltros({ ...filtros, balanceFilter: e.target.value });
  }

  return (
    <Flex
      direction={"column"}
      alignItems={"center"}
      bgColor={"#F5F5F5"}
      maxH="100%"
      w={"99.8%"}
      overflow={"hidden"}
      overflowY={"scroll"}
    >
      <Box
        width={"100%"}
        // bgColor={WHITE}
        height={"fit-content"}
        shadow={"md"}
        mt={"0.3%"}
        mx="auto"
        py={1}
        px={3}
      >
        <Flex
          width={"100%"}
          height={"fit-content"}
          mt={"0.1%"}
          mx="auto"
          py={1}
          px={10}
          flexDirection={"column"}
        >
          <Flex width={"100%"} height={"100%"} justifyContent="space-evenly">
            {/* <Box w={"22%"}>
                            <ClientFilterSelect filtros={filtros} setFiltros={setFiltros} />
                        </Box> */}
            <DateDropdown filtros={filtros} setFiltros={setFiltros} />
            <Select
              placeholder="Filtro de Saldo"
              maxW={"14%"}
              fontSize={"0.8rem"}
              onChange={onChangeBalanceFilter}
              value={filtros.balanceFilter}
            >
              <option value={"N"}>Negativo</option>
              <option value={"Z"}>Zero</option>
              <option value={"P"}>Positivo</option>
            </Select>
            <Button
              bgColor={GRAY_NEUTRAL}
              color={WHITE}
              fontSize={"0.8rem"}
              onClick={() => {
                setFiltros(initialValues);
                // setFiltroAPI("");
                // setFiltroExport("");
              }}
            >
              Limpar Filtros
            </Button>
          </Flex>
        </Flex>
      </Box>
      <Table variant={"striped"} fontSize={"0.8rem"} h={"100%"}>
        <Thead h="50px" position="sticky" top="0" bgColor={BLUEMONEDDBUTTONS}>
          <Tr>
            <Th
              // w={"300px"}
              fontWeight={"bold"}
              borderRadius={"8px 0 0 8px"}
              // textAlign={"center"}
              bgColor={"none"}
              // color={BLUEMONEDDBUTTONS}
              color={"white"}
              fontSize={"11px"}
            >
              Cliente
            </Th>
            <Th color={"white"} fontSize={"11px"}>
              Vendas Crédito
            </Th>
            <Th color={"white"} fontSize={"11px"}>
              Vendas Débito
            </Th>
            <Th color={"white"} fontSize={"11px"}>
              Vendas Boleto
            </Th>
            {/* <Th color={"white"} fontSize={"11px"} >
                        Status
                        </Th> */}
            <Th color={"white"} fontSize={"11px"}>
              Vendas PIX
            </Th>
            <Th color={"white"} fontSize={"11px"}>
              Lançamento Crédito
            </Th>
            <Th color={"white"} fontSize={"11px"}>
              Lançamento Débito
            </Th>
            <Th color={"white"} fontSize={"11px"}>
              Pagamento de Boleto
            </Th>
            {/* <Th color={"white"}>Tipo de Venda</Th> */}
            <Th color={"white"} fontSize={"11px"}>
              Transfrência TED
            </Th>

            <Th color={"white"} fontSize={"11px"}>
              Venda Disputada
            </Th>
            <Th color={"white"} fontSize={"11px"}>
              Saldo Atual
            </Th>
            <Th
              color={"white"}
              borderRadius={"0 8px 8px 0"}
              fontSize={"11px"}
              w={"7vw"}
            >
              Opções
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {linhas.map((item: any, index: any) => {
              // Etapa 1: a linha já existe com o nome e o menu de Detalhes; as
              // células de valor ficam em esqueleto até a consulta pesada
              // responder.
              if (!valoresCarregados) {
                return (
                  <LinhaEsqueleto
                    key={item.id ?? index}
                    item={item}
                    onDetalhes={(idCliente) =>
                      goToConsultaTransacaoCliente(navigate, idCliente)
                    }
                  />
                );
              }

              return (
                <Tr key={index}>
                  <Td fontSize={"12px"}>
                    {item.isCnpj === true
                      ? item.razaoSocial
                      : `${item.nome} ${item.sobrenome}`}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item.vendaCartao
                      ? item?.vendaCartao.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "R$ 0,00"}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item?.vendaCartaoDebito.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item?.vendaBoleto.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item?.vendaPix.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item?.lancamentoManualCredito.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item.lancamentoManualDebito
                      ? item?.lancamentoManualDebito.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "R$ 0,00"}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item.pagamentoBoleto
                      ? item?.pagamentoBoleto.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "R$ 0,00"}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item.transferenciaTED
                      ? item?.transferenciaTED.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "R$ 0,00"}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item.disputaVendaCartao
                      ? item.disputaVendaCartao.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "R$ 0,00"}
                  </Td>
                  <Td fontSize={"0.8rem"}>
                    {item.saldo
                      ? item.saldo.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "R$ 0,00"}
                  </Td>
                  <Td borderRadius={"0 8px 8px 0"} fontSize="12px">
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        aria-label="Options"
                        icon={<HamburgerIcon />}
                        bgColor={BLUEMONEDDBUTTONS}
                        color={WHITE}
                        size={"sm"}
                      />
                      <MenuList>
                        <MenuItem
                          onClick={() => {
                            goToConsultaTransacaoCliente(navigate, item.id);
                          }}
                          icon={<FaSearch />}
                        >
                          Detalhes
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Td>
                </Tr>
              );
          })}
        </Tbody>
      </Table>
    </Flex>
  );
}
